export default [
  {
    id: "ART",
    detail: 'En proceso de reenvío',
    color: 'yellow-100',
    icon: 'mdi-sync'
  },
  {
    id: "PEN",
    detail: 'Pendiente',
    color: 'yellow-100',
    icon: 'mdi-clock'
  },
  {
    id: "FAI",
    detail: 'Pendiente',
    color: 'yellow-100',
    icon: 'mdi-clock'
  },
  {
    id: "REJ",
    detail: 'Rechazado',
    color: 'red-100',
    icon: 'mdi-close-circle-outline'
  },
  {
      id: "VOI",
      detail: 'Anulada',
      color: 'grey-200',
      icon: 'mdi-file-document-remove'
  },
  {
    id: "ASI",
    detail: 'Aceptada',
    color: 'blue-100',
    icon: 'mdi-check-circle-outline'
  },
  {
    id: "UNK",
    detail: 'Fallida',
    color: 'red-100',
    icon: 'mdi-close-circle-outline'
  },
  {
    id: "ERR",
    detail: 'Error',
    color: 'red-100',
    icon: 'mdi-alert-circle-outline'
  }
]